import React, { memo } from 'react';
import { team } from '../mock';

const Team = () => {
  return (
    <section className="py-20 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="font-display text-3xl md:text-5xl font-bold text-center text-brand-navy uppercase title-underline">La Nostra Squadra</h2>
        <p className="text-center text-gray-600 mt-6 max-w-2xl mx-auto">
          Un team di professionisti qualificati, pronti a intervenire con competenza e rapidità.
        </p>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 max-w-6xl mx-auto">
          {team.map((m) => (
            <div key={m.name} className="text-center group">
              <div className="relative w-40 h-40 mx-auto rounded-full overflow-hidden shadow-lg border-4 border-white ring-2 ring-gray-100 group-hover:ring-brand-red transition-all">
                {m.bgZoom ? (
                  <div
                    role="img"
                    aria-label={m.name}
                    className="w-full h-full group-hover:scale-110 transition-transform duration-500"
                    style={{
                      backgroundImage: `url(${m.image})`,
                      backgroundSize: m.bgZoom,
                      backgroundPosition: m.objectPosition || 'center',
                      backgroundRepeat: 'no-repeat',
                    }}
                  />
                ) : (
                  <img src={m.image} alt={m.name} loading="lazy" decoding="async" width="320" height="320" sizes="160px" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" style={{ objectPosition: m.objectPosition || 'center' }} />
                )}
              </div>
              <h4 className="font-display text-lg font-bold text-brand-navy uppercase tracking-wide mt-5">{m.name}</h4>
              <p className="text-sm text-gray-600 mt-1">{m.role}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default memo(Team);
